import styled from "styled-components";
import media from "constants/media";

export const DoublerStyled = styled.div`
    background: var(--color-darkNight);

    ${media.mdUp`
        padding-bottom: 126px; 

        background-image:  url("/images/doubler-letters.svg");
        background-position: 50% 420px;
        background-repeat: no-repeat;
    `}
`;
